// apps/roleforge-app/src/lib/aab-app-url.ts
//
// Issue #1085 — `AabSoftRedirectModal` hardcoded `https://atomicaibuilder.com`.
// That host is no longer where the app lives: `canonical-host.ts` maps
// `atomicaibuilder.com` and `www.atomicaibuilder.com` onto
// `atomic.bonnierandle.com`, which is the domain the
// `atomicaibuilder-deploy.yml` workflow actually provisions. The link
// therefore took a redirect hop, and would break outright if the legacy
// domain is ever retired.
//
// The fix mirrors what the server already does (`aab-app-url.ts`) and what
// apps/web does (`lib/atomic.ts`): resolve the origin from an env var so
// there is one place to change it, not a second hardcoded literal.
//
// Fallback choice — deliberately NOT the beta host the server and apps/web
// fall back to. Those two are authenticated surfaces where a beta build
// reaching beta is correct. This is a public marketing link on a live funnel
// page, so an unset var must degrade to the real production app rather than
// to an internal beta host. Same reasoning as this app's other client
// defaults (`VITE_VIBECONTROL_API_URL` falls back to production
// `api.vibecontrol.app`, not a beta origin).
//
// Vite bakes `import.meta.env` at build time — see .env.example.

/** Canonical production origin of the AtomicAIBuilder course app. */
export const AAB_CANONICAL_APP_URL = 'https://atomic.bonnierandle.com';

/** Base URL of the AtomicAIBuilder course app, trailing slashes stripped. */
export function aabAppUrl(): string {
  const configured = import.meta.env.VITE_AAB_APP_URL as string | undefined;
  const raw = configured?.trim() || AAB_CANONICAL_APP_URL;
  return raw.replace(/\/+$/, '');
}
